const FoundationSection = () => {
  return (
    <section className="py-24 md:py-32 bg-secondary">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-heading font-semibold text-center text-primary mb-12">
          The Lantern Prep Difference
        </h2>
        
        <div className="space-y-8 text-lg leading-relaxed text-muted-foreground">
          <p>
            Most college advisory practices sell access to a name and deliver a junior associate. Lantern Prep is structured differently.
          </p>

          <p>
            Every student works with a senior advising team — led by Andrea Coopersmith and drawing on specialists with the experience the work requires, including former university administrators and credentialed test-prep professionals. The team that begins with a student continues with that student through SAT preparation, school selection, applications, and the questions that come after. No handoffs to junior associates. No rotating staff. The work is rigorous. The cohort is small by design. And every engagement directly contributes to scholarship seats in the same cohort, taught to the same standard.
          </p>

          <p className="font-medium text-foreground text-center pt-4">
            Preparation, by design.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FoundationSection;